import { CircularProgress, ThemeProvider } from "@mui/material";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DialogChatAPI from "./api/dialogChatApi";
import StatisticApi from "./api/statisticApi";
import UsersApi from "./api/usersApi";
import "./App.css";
import { ContextProvider, TypeContextProvider } from "./contextProvider";
import Auth from "./layouts/Auth/Auth";
import Main from "./layouts/Main/Main";
import { TypeUserData } from "./types/TypeUsers";
import { theme } from "./utils/theme";
import "./variables.scss";

function App() {
  const token = localStorage.getItem("token");
  const [isAuth, setIsAuth] = useState(false);
  const [userData, setUserData] = useState<TypeUserData | null | undefined>(
    null,
  );
  const [isLoader, setIsLoader] = useState(true);
  const [unreadMesssageAmount, setUnreadMesssageAmount] = useState(0);
  const [readyToReview, setReadyToReview] = useState(0);
  const [userIdForCreate, setUserIdForCreate] = useState<string | null>(null);

  useEffect(() => {
    const makeAsync = async () => {
      if (!token || !userData) return;
      const unreadMessagesResponse =
        await DialogChatAPI.getUnreadDialogMessagesLength(token);
      const response = await StatisticApi.getAdminDashboardStats(token);
      if (response.status && response.statistics) {
        const readyToReview = response.statistics.profilesReadyToReview;
        setReadyToReview(readyToReview);
      }
      if (unreadMessagesResponse.status) {
        setUnreadMesssageAmount(unreadMessagesResponse.amount);
      }
    };
    const intervalId = setInterval(makeAsync, 60000);
    return () => clearInterval(intervalId);
  }, [token, userData]);

  useEffect(() => {
    if (token) {
      setIsAuth(true);
    } else {
      setIsAuth(false);
    }
  }, [token]);
  useEffect(() => {
    const makeAsync = async () => {
      if (!token) return setIsLoader(false);
      setIsAuth(true);
      try {
        const responseUserData = await UsersApi.getUserByToken(token);
        setIsLoader(false);
        if (responseUserData && responseUserData.roles) {
          localStorage.setItem("userId", responseUserData._id);
          setIsAuth(true);
          setUserData(responseUserData);
        } else {
          setIsAuth(false);
        }
      } catch (error: any) {
        if (error.response && error.response.status === 401) {
          setIsAuth(false);
          setIsLoader(false);
        } else {
          console.error("Error during API request:", error);
          setIsAuth(false);
          setIsLoader(false);
        }
      }
    };

    makeAsync();
  }, [token]);

  const contextValue: TypeContextProvider = {
    isAuth,
    setIsAuth,
    userData,
    unreadMesssageAmount,
    readyToReview,
    userIdForCreate,
    setUserIdForCreate,
  };
  if (isLoader) {
    return (
      <div className="loader-container">
        <ThemeProvider theme={theme}>
          <CircularProgress size={150} color="primary" />
        </ThemeProvider>
      </div>
    );
  }

  return (
    <ContextProvider.Provider value={contextValue}>
      {isAuth ? <Main /> : <Auth />}
      <ToastContainer />
    </ContextProvider.Provider>
  );
}

export default App;
